import React from 'react';
import { Table, TableBody, TableContainer } from '@mui/material';

import { useAppSelector } from '../../../../hooks';
import useTable, {
  defaultRowsPerPageOptions,
  TUseTableState,
} from '../../../../components/V2/Table/type1/useTable';
import TableHeadCustom, {
  THeadLabelItem,
} from '../../../../components/V2/Table/type1/TableHeadCustom';
import SubTopicRow from './components/SubTopicRow';
import { getSubmissionsV2State } from '../../../../store/V2/SubmissionsSlice';

const defaultOrderBy = 'createdAt';
const defaultOrder = 'desc';
const defaultTableData: TUseTableState = {
  defaultOrderBy,
  defaultOrder,
  defaultDense: false,
  defaultCurrentPage: 0,
  defaultRowsPerPage: defaultRowsPerPageOptions[0],
  defaultSelected: [],
};

const tableHeaderLabels: THeadLabelItem[] = [
  {
    id: 'subTopic',
    label: 'Sub Topic',
    sortable: false,
  },
  {
    id: 'lastSubmission',
    label: 'Last Submission',
    sortable: false,
    minWidth: 120,
  },
  {
    id: 'score',
    label: 'Score (Avg)',
    sortable: false,
  },
  {
    id: 'timeTaken',
    label: 'Time taken (Avg)',
    sortable: false,
    minWidth: 80,
  },
  {
    id: 'attempt',
    label: 'Attempt',
    sortable: false,
    minWidth: 130,
  },
];

interface IStudentDetailedOverviewProps {
  topicId: string;
}

const SubTopicPerformanceTable: React.FC<IStudentDetailedOverviewProps> = ({
  topicId,
}) => {
  // Store
  const { groupedSubTopicsSubmissions } = useAppSelector(getSubmissionsV2State);

  // State
  const tableData = useTable(defaultTableData);

  const selectedTopicSubmission = groupedSubTopicsSubmissions.find(
    (item) => item.topicId === topicId
  );

  return (
    <div>
      <TableContainer
        sx={{
          position: 'relative',
        }}
      >
        <Table stickyHeader size={tableData.dense ? 'small' : 'medium'}>
          <TableHeadCustom
            order={tableData.order}
            orderBy={tableData.orderBy}
            headLabels={tableHeaderLabels}
            rowCount={0}
            numSelected={tableData.selected.length}
          />

          <TableBody>
            {selectedTopicSubmission?.subTopics.map((row) => (
              <SubTopicRow
                key={row.subTopicId}
                rowData={row}
                topicId={topicId}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default SubTopicPerformanceTable;
